/**
 * @generated SignedSource<<d0d187cc02289f15762fa32bb4e2164f>>
 * @relayHash 30c2a89460070692193c3257a69f6973
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2298927a4ea816a29ee9dc52b84b9608a9ee125aaf2e273a63a05895a85b4825

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JsmProjectMenuWrapper_SidebarQuery$variables = {
  cloudId: string;
  isRenamingEnabled: boolean;
  projectKey: string;
};
export type JsmProjectMenuWrapper_SidebarQuery$data = {
  readonly jira_projectLevelSidebarMenuCustomization: {
    readonly __typename: "JiraProjectLevelSidebarMenuCustomization";
    readonly hiddenMenuItems: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly itemId: string;
        } | null;
      } | null> | null;
    } | null;
    readonly renamedMenuItems?: {
      readonly " $fragmentSpreads": FragmentRefs<"JsmProjectMenuContent_renamedMenuItems">;
    } | null;
  } | {
    readonly __typename: "QueryError";
    readonly __typename: "QueryError";
    readonly message: string | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type JsmProjectMenuWrapper_SidebarQuery = {
  response: JsmProjectMenuWrapper_SidebarQuery$data;
  variables: JsmProjectMenuWrapper_SidebarQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isRenamingEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "projectKey",
    "variableName": "projectKey"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "itemId"
},
v6 = {
  "concreteType": "JiraProjectLevelSidebarMenuItemConnection",
  "kind": "LinkedField",
  "name": "hiddenMenuItems",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraProjectLevelSidebarMenuItemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraProjectLevelSidebarMenuItem",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v5/*: any*/)
          ]
        }
      ]
    }
  ]
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "QueryError"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "JsmProjectMenuWrapper_SidebarQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "kind": "LinkedField",
        "name": "jira_projectLevelSidebarMenuCustomization",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              {
                "condition": "isRenamingEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "JiraProjectLevelSidebarRenamedMenuItemConnection",
                    "kind": "LinkedField",
                    "name": "renamedMenuItems",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "JsmProjectMenuContent_renamedMenuItems"
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "JiraProjectLevelSidebarMenuCustomization"
          },
          (v7/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "JsmProjectMenuWrapper_SidebarQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "kind": "LinkedField",
        "name": "jira_projectLevelSidebarMenuCustomization",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              {
                "condition": "isRenamingEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "JiraProjectLevelSidebarRenamedMenuItemConnection",
                    "kind": "LinkedField",
                    "name": "renamedMenuItems",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraProjectLevelSidebarRenamedMenuItemEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraProjectLevelSidebarRenamedMenuItem",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "renamedMenuItemName"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ],
            "type": "JiraProjectLevelSidebarMenuCustomization"
          },
          (v7/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "2298927a4ea816a29ee9dc52b84b9608a9ee125aaf2e273a63a05895a85b4825",
    "metadata": {},
    "name": "JsmProjectMenuWrapper_SidebarQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b2e346bf89908f8dbaf1941dbed37620";

export default node;
